import { Injectable } from '@angular/core';
import { chartColors } from '../static-data/chart.config';

@Injectable({
  providedIn: 'root'
})
export class ChartsService {

  constructor() { }

  // 📊 رسم بياني عمودي احترافي - المستهدف والمحقق
  getColumnChartOptions(indicator: any, dir: 'rtl' | 'ltr') {
    const metaData = {
      name: indicator.name,
      in_charge_name: indicator.in_charge_name,
    };

    const categories: string[] = [];
    const targets: number[] = [];
    const actuals: number[] = [];

    const outcomes = indicator['mob_charts']['data'];

    for (let index = 0; index < outcomes.length; index++) {
      const { name, target, actual } = outcomes[index];
      categories.push(name);
      targets.push(target || 0);
      actuals.push(actual || 0);
    }

    const title = dir === 'rtl'
      ? `${metaData.name}`
      : `${metaData.name}`;

    return {
      customType: "column-due",
      metaData,
      series: [
        {
          name: dir === 'rtl' ? "المستهدف" : "Target",
          data: targets,
          color: '#C91F3B'
        },
        {
          name: dir === 'rtl' ? "المحقق" : "Actual",
          data: actuals,
          color: '#546e7a'
        }
      ],
      chart: {
        type: "bar",
        height: 450,
        toolbar: {
          show: true,
          tools: {
            download: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        },
        fontFamily: 'Cairo, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
        }
      },
      colors: ['#C91F3B', '#546e7a'],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          borderRadius: 6,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 4,
        padding: {
          top: 0,
          right: 20,
          bottom: 0,
          left: 20
        },
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        }
      },
      xaxis: {
        categories: categories,
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Cairo, sans-serif',
            fontWeight: 600,
            colors: '#546e7a'
          },
          rotate: -45,
          rotateAlways: false,
          trim: false
        },
        axisBorder: {
          show: true,
          color: '#e0e0e0'
        },
        axisTicks: {
          show: true,
          color: '#e0e0e0'
        }
      },
      yaxis: {
        title: {
          text: '',
          style: {
            fontSize: '13px',
            fontFamily: 'Cairo, sans-serif',
            fontWeight: 600,
            color: '#546e7a'
          }
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Cairo, sans-serif',
            colors: '#546e7a'
          },
          formatter: function (val: any) {
            return val ? val.toFixed(0) + '%' : '0%';
          }
        },
        min: 0
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        fontSize: '14px',
        fontFamily: 'Cairo, sans-serif',
        fontWeight: 600,
        markers: {
          width: 12,
          height: 12,
          radius: 3
        },
        itemMargin: {
          horizontal: 15,
          vertical: 10
        }
      },
      tooltip: {
        theme: 'light',
        shared: true,
        intersect: false,
        style: {
          fontSize: '13px',
          fontFamily: 'Cairo, sans-serif'
        },
        x: {
          show: true
        },
        y: {
          formatter: function (val: any) {
            return val ? val.toFixed(2) + '%' : '0%';
          }
        },
        marker: {
          show: true
        }
      }
    };
  }



  // 📍 رسم بياني بعلامات الهدف (Marker Chart) - مع ألوان ديناميكية
  getMarkerChartOptions(indicator: any, customLegendItems: any, dir: 'rtl' | 'ltr') {
    const metaData = {
      name: indicator.name,
      in_charge_name: indicator.in_charge_name,
    };

    const title = dir === 'rtl' 
      ? `${metaData.name}` 
      : `${metaData.name}`;

    const colors: string[] = [];
    const data = indicator['mob_charts']['data'].map((chart: any) => {
      const targetNum = Number(chart['target']) || 0;
      const actualNum = Number(chart['actual']) || 0;
      
      // تحديد اللون بناءً على المقارنة
      let barColor: string;
      if (targetNum > 0 && actualNum >= targetNum) {
        barColor = '#10b981'; // أخضر - Green
      } else if (targetNum > 0 && actualNum < targetNum) {
        barColor = '#546e7a'; // رمادي - Grey  
      } else {
        barColor = '#94a3b8'; // رمادي فاتح - Light Grey
      }
      
      colors.push(barColor);
      
      return {
        x: chart['name'],
        y: chart['actual'] || 0,
        fillColor: barColor,
        goals: [
          {
            name: dir === 'rtl' ? 'المستهدف' : 'Target',
            value: chart['target'] || 0,
            strokeColor: '#C91F3B',
            strokeHeight: 4,
            strokeWidth: 10,
            strokeDashArray: 0
          }
        ]
      };
    });

    return {
      customType: "column-marker",
      metaData,
      series: [
        {
          name: dir === 'rtl' ? "المحقق" : "Actual",
          data: data
        }
      ],
      colors: colors,
      chart: {
        height: 450,
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        },
        fontFamily: 'Cairo, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
          borderRadius: 6,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 4,
        padding: {
          top: 20,
          right: 20,
          bottom: 0,
          left: 20
        },
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        }
      },
      xaxis: {
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Cairo, sans-serif',
            fontWeight: 600,
            colors: '#546e7a'
          },
          rotate: -45,
          rotateAlways: false,
          trim: false
        },
        axisBorder: {
          show: true,
          color: '#e0e0e0'
        },
        axisTicks: {
          show: true,
          color: '#e0e0e0'
        }
      },
      yaxis: {
        title: {
          text: '',
          style: {
            fontSize: '13px',
            fontFamily: 'Cairo, sans-serif',
            fontWeight: 600,
            color: '#546e7a'
          }
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Cairo, sans-serif',
            colors: '#546e7a'
          },
          formatter: function (val: any) {
            return val ? val.toFixed(0) + '%' : '0%';
          }
        },
        min: 0
      },
      legend: {
        show: false
      },
      tooltip: {
        theme: 'light',
        shared: false,
        intersect: true,
        style: {
          fontSize: '13px',
          fontFamily: 'Cairo, sans-serif'
        },
        x: {
          show: true,
          formatter: function(val: any) {
            return val;
          }
        },
        y: {
          formatter: function (val: any) {
            return val ? val.toFixed(2) + '%' : '0%';
          },
          title: {
            formatter: (seriesName: string) => dir === 'rtl' ? 'المحقق: ' : 'Actual: '
          }
        },
        marker: {
          show: true
        }
      }
    };
  }

}
